/**
 * Create a single instance of all the services to inject them into Vue app
 * 
 * This is so that there aren't multiple instance of AuthServices, only a single MSAL object
 * should be created
 */
import AuthService from './AuthService.js'
import TimesheetApi from './TimesheetApi.js'
import MSgraphApi from './MSgraphApi.js'

export const authService = new AuthService();
export const timesheetApi = new TimesheetApi(authService);
export const msGraphApi = new MSgraphApi();
